// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Help = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48.5 13C28.925 13 13 28.925 13 48.5S28.925 84 48.5 84 84 68.075 84 48.5 68.075 13 48.5 13m0 75C26.72 88 9 70.28 9 48.5S26.72 9 48.5 9 88 26.72 88 48.5 70.28 88 48.5 88Zm-2-27.933c0 1.105.896 1.964 2 1.964 1.081 0 1.961-.891 1.999-1.964l.001-3.072c0-3.203 2.57-5.1 5.057-6.933 1.258-.928 2.447-1.805 3.248-2.85 2.329-3.036 3.195-5.4 3.195-8.717 0-7.443-6.056-13.5-13.5-13.5S35 31.052 35 38.495a2 2 0 0 0 4 0c0-5.238 4.262-9.5 9.5-9.5s9.5 4.262 9.5 9.5c0 2.418-.575 3.945-2.369 6.283-.456.595-1.424 1.309-2.449 2.065-2.82 2.08-6.682 4.929-6.682 10.152v3.072Zm1.996 12.932a2.997 2.997 0 0 0 2.997-2.997v-.015A2.991 2.991 0 0 0 48.496 67a3.004 3.004 0 0 0-2.996 3.003A2.997 2.997 0 0 0 48.496 73Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default Help;
